
  
import apiClient from '../config/axios';
import ENDPOINTS from '../constants/endpoints';

export const localService = {
  // Get locaux with pagination and filters
  getLocaux: async (pageSize = 10, page = 1, filters = {}) => {
    try {
      // Build the URL with path parameters for pagination
      const url = `${ENDPOINTS.LOCAUX}/${pageSize}/${page}`;
      
      // Build query parameters for filters only
      const params = {};

      // Add filters if they exist
      if (filters.searchTerms) {
        params.SearchTerms = filters.searchTerms;
      }
      if (filters.clientId) {
        params.ClientId = filters.clientId;
      }
      if (filters.adresse) {
        params.Adresse = filters.adresse;
      }
      if (filters.responsable) {
        params.Responsable = filters.responsable;
      }

      const response = await apiClient.get(url, {
        params: params
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching locaux:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement des locaux',
        error: error.response?.data,
      };
    }
  },
  // Get locaux by clientId
  getLocauxByClient: async (clientId) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.LOCAUX}/byClient/${clientId}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Error fetching locaux by client:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement des locaux du client',
        error: error.response?.data,
      };
    }
  },
  // Get locaux by clientId

  // Get local by ID
  getLocalById: async (id) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.LOCAUX}/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get local by ID error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement du local',
        error: error.response?.data,
      };
    }
  },

  // Create new local
  createLocal: async (localData) => {
    try {
      const response = await apiClient.post(ENDPOINTS.LOCAUX, localData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Create local error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la création du local',
        error: error.response?.data,
      };
    }
  },

  // Update local
  updateLocal: async (id, localData) => {
    try {
      const response = await apiClient.put(`${ENDPOINTS.LOCAUX}/${id}`, localData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Update local error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la mise à jour du local',
        error: error.response?.data,
      };
    }
  },

  // Delete local
  deleteLocal: async (id) => {
    try {
      const response = await apiClient.delete(`${ENDPOINTS.LOCAUX}/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Delete local error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la suppression du local',
        error: error.response?.data,
      };
    }
  },
};

export default localService;